var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-5",attrs:{"x-large":""}},'v-icon',attrs,false),on),[_vm._v("\n      "+_vm._s(_vm.icon)+"\n    ")])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.summary))])])
}
var staticRenderFns = []

export { render, staticRenderFns }